const stationtpl = resolve => require(['@/pages/station/modules'], resolve);
const recommend = resolve => require(['@/pages/station/recommend'], resolve);
const itemsGoods = resolve => require(['@/pages/station/modules/channel/items/itemsGoods'], resolve);
const selling = resolve => require(['@/pages/station/modules/selling'], resolve);
const agegoods = resolve => require(['@/pages/station/modules/agegoods'], resolve);
const ages = resolve => require(['@/pages/station/modules/ages'], resolve);
const startPage = resolve => require(['@/pages/stationmanage/startPage'], resolve);
const startPagePublish = resolve => require(['@/pages/stationmanage/startPage/startPagePublish'], resolve);
const homeDialog = resolve => require(['@/pages/stationmanage/homeDialog'], resolve);
const addDialog = resolve => require(['@/pages/stationmanage/homeDialog/addDialog'], resolve);

export default [
    /****************站点管理******************/
    {
        path: "/stationtpl",
        name: "模板管理",
        meta: {
            keepAlive: true
        },
        component: stationtpl
    },
    //推荐位管理
    {
        path: "/recommend",
        name: "推荐位管理",
        component: recommend
    },
    {
        path: "/stationsystem",
        meta: { keepAlive: true },
        name: "系统页面管理",
        // component: () => import("@/pages/station/modules")
        component: () =>
            import ("@/pages/stationmanage/pagemanage")
    },
    {
        path: "/custom",
        name: "自定义页面管理",
        component: () =>
            import ("@/pages/stationmanage/pagemanage/custom.vue")
    },
    {
        path: "/preview/:channelId",
        name: "预览",
        component: () =>
            import ("@/pages/stationmanage/preview")
    },
    {
        path: "/renovation/:channelId",
        name: "页面装修",
        component: () =>
            import ("@/pages/stationmanage/renovation")
    },
    {
        path: "/startPage",
        name: "启动页管理",
        component: startPage,
    },
    {
        path: "/startPage/publish",
        name: "启动页管理发布",
        component: startPagePublish,
    },
    /*模板管理下的路由开始*/
    {
        path: "/stationtpl/items/:index",
        name: "频道",
        component: itemsGoods
    },
    {
        path: "/stationtpl/ages",
        name: "孕期",
        component: ages
    },
    {
        path: "/stationtpl/agegoods/:position",
        name: "孕期产品",
        component: agegoods
    },
    {
        path: "/stationtpl/selling/:type",
        name: "热销新货",
        component: selling
    },
    /*模板管理下的路由结束*/
    {
        path: "/homeDialog",
        name: "首页弹窗配置管理",
        component: homeDialog
    },
    {
        path: "/addDialog/:popupId",
        name: "新增弹窗",
        component: addDialog
    }
]